import { Component, type ErrorInfo, type ReactNode } from "react";

type State = { error: Error | null };

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Kidix interface error", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="app-error">
      <section>
        <span className="eyebrow">Kidix recovery</span>
        <h1>The page could not finish loading.</h1>
        <p>Refresh once to load the latest version. Your account and saved work are safe.</p>
        <button className="button button--dark" type="button" onClick={() => window.location.reload()}>Refresh Kidix</button>
      </section>
    </main>;
  }
}
